module.exports = __webpack_public_path__ + "static/hobbes-ead4f82600086b81a2ca88a567d09c90.png";